export enum UIDataEventType {
  Standard = 'standard',
  Timer = 'timer'
}
